import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
    selector: 'liebherr-dialog-loading',
    templateUrl: './dialog-loading.component.html',
    styleUrls: ['./dialog-loading.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DialogLoadingComponent {
    constructor() {}
}
